"use strict";
const { number, object, string } = require('../utils/modifiedYup');
const { durationSchema, MILLISECONDS_PER_MINUTE } = require('./durationSchema');
// Minimum duration is 15 minutes
const MINIMUM_DURATION_MINUTES = 15;
const PROD_MINIMUM_DURATION_MILLSECONDS = MINIMUM_DURATION_MINUTES * MILLISECONDS_PER_MINUTE;
const ENGINE_INTEGRATION_TEST_MINIMUM_DURATION_MILLISECONDS = 100;
const MINIMUM_DURATION_MILLISECONDS = process.env.ENGINE_INTEGRATION_TESTING === 'true'
    ? ENGINE_INTEGRATION_TEST_MINIMUM_DURATION_MILLISECONDS
    : PROD_MINIMUM_DURATION_MILLSECONDS;
const collectResponsesSchema = object().shape({
    duration: durationSchema
        .minimumDuration(MINIMUM_DURATION_MILLISECONDS)
        .required(),
});
exports.smsResponseCaptureSchema = object().shape({
    stepName: string().required(),
    collectResponses: collectResponsesSchema.required(),
    messageId: object()
        .shape({
        variableId: string().required(),
        stepId: number().integer(),
        valueType: string().required().oneOf(['number']),
    })
        .required(),
});
exports.webformResponseCaptureSchema = object().shape({
    stepName: string().required(),
    collectResponses: collectResponsesSchema.required(),
    token: object()
        .shape({
        variableId: string().required(),
        stepId: number().integer(),
        valueType: string().required().oneOf(['string']),
    })
        .required(),
});
//# sourceMappingURL=responseCaptureSchema.js.map